import NutritionSummary from "./NutritionSummaryCard";

/** Basis line for a weekly / monthly kit's daily values. */
export const perDayBasis = ({ people }) => (people > 1 ? "per person/day" : "per day");

/**
 * What a weekly / monthly kit gives each day. `perDay` comes from the
 * storefront: { days, people, total, perPerson }.
 */
function KitPerDay({ perDay, perKit }) {
  const { days, people, total, perPerson } = perDay;
  const lasts = `${days} days${people > 1 ? ` for ${people} people` : ""}`;

  return (
    <section aria-labelledby="per-day-title" style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <h2 id="per-day-title" className="ep-section-title" style={{ justifyContent: "flex-start" }}>
        Every Day <small>({perDayBasis(perDay)})</small>
      </h2>
      <NutritionSummary values={perPerson} basis={perDayBasis(perDay)} />
      <p className="ep-prose">
        One kit lasts {lasts}
        {perKit && ` and holds ${Math.round(perKit.protein)} g of protein in all`}.
        {people > 1 && ` That is ${Math.round(total.protein)} g of protein a day for the family.`}
      </p>
    </section>
  );
}

export default KitPerDay;
